import { css } from '@linaria/core';
import { styled } from '@linaria/react';

export const Wrapper = styled.div`
	display: flex;
	width: 100%;
	flex-direction: column;
	align-items: center;
	gap: var(--gap-x5);
`;

export const image = css`
	width: auto;
	height: 125px;
`;

export const ModalWrapper = styled.div`
	position: relative;
	display: flex;
	width: 360px;
	flex-direction: column;
	padding: 40px;
	border-radius: var(--radius-s);
	margin: auto;
	background-color: var(--color-grey-10-solid);
	gap: var(--gap-x3);

	& > *:first-child {
		position: absolute;
		top: -50px;
		right: 0;
	}

	& > *:last-child {
		margin-top: 30px;
	}
`;
